import { URL } from './urls';

export default function getTeleconnectSales(accesToken, company_id, reseller_id) {
  const apiURL = URL + `/teleconnect_graphs?company_id=${company_id}&reseller_id=${reseller_id}`

  return fetch(apiURL, {
    headers: {
      'Authorization': `Bearer ${accesToken}`
    }
  })
    .then(res => res.json())
    .then(response => {
      return response
    })
}